import React, { Component } from "react";
import config from "lib/fr-config";
import { getDeviceType } from "lib/deviceInfo";
import TextButtonView from "presentational/common/TextButtonView";
import ColonTextButtonView from "presentational/common/ColonTextButtonView";
import CategorySelectorModalView from "presentational/common/modals/CategorySelectorModalView";
import ColorSelectorModalView from "presentational/common/modals/ColorSelectorModalView";
import BrandSelectorModalView from "presentational/common/modals/BrandSelectorModalView";
import TagSelectorModalView from "presentational/common/modals/TagSelectorModalView";
import TXT from "presentational/common/multinational/TXT";
import styles from "./ItemInfoInputPanelView.scss";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

class ItemInfoInputPanelView extends Component {
  static propTypes = {
    nextQueryObj: PropTypes.shape({
      category: PropTypes.string,
      brand: PropTypes.string,
      color: PropTypes.string,
      tag: PropTypes.string,
      gender: PropTypes.string
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onOptionResetBtnClick: PropTypes.func.isRequired
  };

  state = {
    categoryModalOpen: false,
    brandModalOpen: false,
    colorModalOpen: false,
    tagModalOpen: false
  };

  getCss = () => {
    return {
      root: {
        marginBottom:
          getDeviceType() === "mobile"
            ? mobileCss.standardPaddingBetweenContent
            : desktopCss.standardPaddingBetweenContent
      }
    };
  };

  async clearCategoryOption() {
    const { onChange } = this.props;
    await onChange("category", undefined);
  }

  async clearSecondOption() {
    const { onChange } = this.props;
    await onChange("brand", undefined);
    await onChange("color", undefined);
    await onChange("tag", undefined);
  }

  handleButtonClick = type => () => {
    switch (type) {
      case "category":
        this.setState({ categoryModalOpen: true });
        break;
      case "brand":
        this.setState({ brandModalOpen: true });
        break;
      case "color":
        this.setState({ colorModalOpen: true });
        break;
      case "tag":
        this.setState({ tagModalOpen: true });
        break;
      default:
        console.error("error");
        console.log("error");
        break;
    }
  };

  handleModalClose = () => {
    this.setState({
      categoryModalOpen: false,
      brandModalOpen: false,
      colorModalOpen: false,
      tagModalOpen: false
    });
  };

  handleClearWholeTypeBtnClick = async () => {
    const { onOptionResetBtnClick } = this.props;
    await this.clearCategoryOption();
    await this.clearSecondOption();
    onOptionResetBtnClick();
  };

  handleClearOptionTypeBtnClick = async () => {
    const { onSubmit } = this.props;
    await this.clearSecondOption();
    onSubmit();
  };

  handleSelect = type => async value => {
    const { onChange, onSubmit } = this.props;
    await onChange(type, value);

    switch (type) {
      case "category":
        if (!value) {
          await this.clearSecondOption();
        } else {
          onSubmit();
        }
        break;
      case "brand":
      case "color":
      case "tag":
        onSubmit();
        break;
      default:
        break;
    }
  };

  handleSubmitBtn = gender => async () => {
    const { onChange, onSubmit } = this.props;
    await onChange("gender", gender);
    onSubmit();
  };

  render() {
    const { nextQueryObj } = this.props;
    const { categoryModalOpen, brandModalOpen, colorModalOpen, tagModalOpen } =
      this.state;
    const { category, brand, color, tag, gender } = nextQueryObj;
    const css = this.getCss();

    return (
      <div className={cx("root")} style={css.root}>
        <div className={cx("category-button-area")}>
          <ColonTextButtonView
            disableRightMargin
            onClick={this.handleButtonClick("category")}
            primary={<TXT name="btnSelect_category" />}
            secondary={
              category && (
                <TXT
                  textType="category"
                  categoryType="itemLabelName"
                  name={category}
                />
              )
            }
            onClear={this.handleClearWholeTypeBtnClick}
            showClearButton={!!category}
          />
        </div>
        {category && (brand || color || tag) && (
          <div className={cx("second-option-button-area")}>
            {brand && (
              <ColonTextButtonView
                onClick={this.handleButtonClick("brand")}
                disableRightMargin
                primary={<TXT name="btnSelect_brand" />}
                secondary={brand || null}
                onClear={this.handleClearOptionTypeBtnClick}
                showClearButton
              />
            )}
            {color && (
              <ColonTextButtonView
                onClick={this.handleButtonClick("color")}
                disableRightMargin
                primary={<TXT name="btnSelect_color" />}
                secondary={color ? <TXT textType="color" name={color} /> : null}
                onClear={this.handleClearOptionTypeBtnClick}
                showClearButton
              />
            )}
            {tag && (
              <ColonTextButtonView
                onClick={this.handleButtonClick("tag")}
                disableRightMargin
                primary={<TXT name="btnSelect_hash" />}
                secondary={tag || null}
                onClear={this.handleClearOptionTypeBtnClick}
                showClearButton
              />
            )}
          </div>
        )}
        {category && !brand && !color && !tag && (
          <div className={cx("option-select-button-area")}>
            <TextButtonView
              design={"unselect"}
              onClick={this.handleButtonClick("brand")}
            >
              <TXT name="btnSelect_brand" />
            </TextButtonView>
            <TextButtonView
              design={"unselect"}
              onClick={this.handleButtonClick("color")}
            >
              <TXT name="btnSelect_color" />
            </TextButtonView>
            <TextButtonView
              disableRightMargin
              design={"unselect"}
              onClick={this.handleButtonClick("tag")}
            >
              <TXT name="btnSelect_hash" />
            </TextButtonView>
          </div>
        )}
        {category && (
          <div className={cx("gender-button-area")}>
            <TextButtonView
              design={gender === "female" ? "select" : "unselect"}
              onClick={this.handleSubmitBtn("female")}
              disabled={!category}
            >
              <TXT name="btnSelect_femaleGroup" />
            </TextButtonView>
            <TextButtonView
              disableRightMargin
              design={gender === "male" ? "select" : "unselect"}
              onClick={this.handleSubmitBtn("male")}
              disabled={!category}
            >
              <TXT name="btnSelect_maleGroup" />
            </TextButtonView>
          </div>
        )}
        <CategorySelectorModalView
          value={category}
          open={categoryModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleSelect("category")}
        />
        <ColorSelectorModalView
          value={color}
          open={colorModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleSelect("color")}
        />
        <BrandSelectorModalView
          value={brand}
          open={brandModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleSelect("brand")}
        />
        <TagSelectorModalView
          value={tag}
          open={tagModalOpen}
          onClose={this.handleModalClose}
          onSelect={this.handleSelect("tag")}
        />
      </div>
    );
  }
}

export default ItemInfoInputPanelView;
